import { atomWithReset } from 'jotai/utils';

/** The content of the error message to show. */
export const loginCodeEmailRequestErrorMessageAtom = atomWithReset<string | null>(null);

/** Whether a login code is currently being sent via email. */
export const isSendingLoginCodeAtom = atomWithReset<boolean>(false);